import { render, staticRenderFns } from "./DataMapping.vue?vue&type=template&id=a03fe764&"
import script from "./DataMapping.vue?vue&type=script&lang=js&"
export * from "./DataMapping.vue?vue&type=script&lang=js&"
import style0 from "./DataMapping.vue?vue&type=style&index=0&id=a03fe764&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports